(function () {
  if (window.saleNavBoot) { window.saleNavBoot(document); return; }
  var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  function headerNode() { return document.querySelector("#header-component"); }
  function headerHidden() {
    var h = headerNode();
    return !!h && (h.getAttribute("data-sticky-state") === "idle" || h.hasAttribute("data-animating"));
  }
  function boot(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    if (root.nodeType === 1 && root.hasAttribute("data-sale-nav")) { init(root); return; }
    var nodes = root.querySelectorAll("[data-sale-nav]");
    for (var i = 0; i < nodes.length; i++) init(nodes[i]);
  }
  function init(root) {
    if (!root || root.dataset.bound === "1") return;
    root.dataset.bound = "1";
    var track = root.querySelector("[data-track]");
    var links = [].slice.call(root.querySelectorAll("[data-anchor]"));
    if (!track || !links.length) return;
    var sectionEl = root.closest(".shopify-section") || root;
    var ac = new AbortController(), signal = ac.signal;
    var locking = false, lockTimer = 0, activeId = "", lastY = window.pageYOffset || 0, drag = { on: false, x: 0, left: 0, moved: false };
    root.__saleNavAbort = ac;
    function stack() {
      var max = 0, hide = headerHidden(), sections = document.querySelectorAll(".shopify-section");
      for (var i = 0; i < sections.length; i++) {
        var el = sections[i]; if (el === sectionEl) continue;
        if (hide && el.querySelector("#header-component")) continue;
        var pos = getComputedStyle(el).position;
        if (pos !== "sticky" && pos !== "fixed") continue;
        var rect = el.getBoundingClientRect();
        if (rect.top <= max + 2 && rect.bottom > max) max = Math.round(rect.bottom);
      }
      return max;
    }
    function offset() {
      var t = root.dataset.sticky === "true" ? (parseFloat(sectionEl.style.top) || 0) : stack();
      if (root.dataset.sticky === "true") t += sectionEl.offsetHeight || 0;
      return t;
    }
    function pin() {
      if (root.dataset.sticky !== "true") return;
      var y = window.pageYOffset || 0, mobile = window.matchMedia("(max-width: 749px)").matches, topPx;
      if (mobile) {
        topPx = parseFloat(sectionEl.style.top);
        if (isNaN(topPx)) topPx = 68;
        if (y <= 0 || y < lastY) topPx = 68;
        else if (y > lastY) topPx = 0;
      } else topPx = stack();
      lastY = y;
      var top = topPx + "px", hidden = mobile && topPx === 0, changed = sectionEl.style.top !== top;
      var h = headerNode(), box = h && h.closest(".shopify-section");
      if (box) box.style.pointerEvents = hidden ? "none" : "";
      if (hidden) sectionEl.style.zIndex = "9";
      if (changed) sectionEl.style.top = top;
      if (!hidden && (!changed || reduce)) sectionEl.style.zIndex = "";
      if (!sectionEl.hasAttribute("data-pin-ready")) {
        requestAnimationFrame(function () { sectionEl.setAttribute("data-pin-ready", ""); });
      }
    }
    function layout() {
      track.style.paddingLeft = ""; track.style.paddingRight = "";
      track.classList.toggle("is-scrollable", track.scrollWidth > track.clientWidth + 1);
    }
    function center(link, smooth) {
      if (!link || !track.classList.contains("is-scrollable")) return;
      var pad = parseFloat(getComputedStyle(track).paddingLeft) || 0;
      var d = link.getBoundingClientRect().left - track.getBoundingClientRect().left - pad;
      if (Math.abs(d) < 1) return;
      track.scrollTo({ left: Math.max(0, track.scrollLeft + d), behavior: smooth && !reduce ? "smooth" : "auto" });
    }
    function activate(link, smooth) {
      var id = link.getAttribute("data-anchor") || "";
      for (var i = 0; i < links.length; i++) {
        var on = links[i] === link;
        links[i].classList.toggle("is-active", on);
        if (on) links[i].setAttribute("aria-current", "true"); else links[i].removeAttribute("aria-current");
      }
      if (id !== activeId) { activeId = id; center(link, smooth); }
    }
    function targetOf(link) {
      var id = (link.getAttribute("data-anchor") || "").trim(), hash = id.lastIndexOf("#");
      if (hash >= 0) id = id.slice(hash + 1); if (!id) return null;
      var found = document.getElementById(id);
      return found || (!window.CSS ? null : document.querySelector('[id$="__' + CSS.escape(id) + '"]'));
    }
    function release() { if (!locking) return; locking = false; spy(); }
    function scrollToEl(el) {
      locking = true; window.clearTimeout(lockTimer); pin();
      window.scrollTo({ top: Math.max(0, el.getBoundingClientRect().top + window.pageYOffset - offset()), behavior: reduce ? "auto" : "smooth" });
      lockTimer = window.setTimeout(release, 1200);
    }
    function spy() {
      if (locking || drag.on) return; pin();
      var line = offset() + 12, current = null;
      for (var i = 0; i < links.length; i++) {
        var el = targetOf(links[i]);
        if (el && el.getBoundingClientRect().top <= line) current = links[i];
      }
      activate(current || links[0], true);
    }
    function place() { layout(); pin(); center(track.querySelector(".is-active"), false); }
    track.addEventListener("pointerdown", function (e) {
      if (e.pointerType !== "mouse" || e.button !== 0 || !track.classList.contains("is-scrollable")) return;
      drag.on = true; drag.moved = false; drag.x = e.clientX; drag.left = track.scrollLeft; track.classList.add("is-dragging");
    }, { signal: signal });
    window.addEventListener("pointermove", function (e) {
      if (!drag.on) return; var dx = e.clientX - drag.x; if (Math.abs(dx) > 5) drag.moved = true; track.scrollLeft = drag.left - dx;
    }, { signal: signal });
    function endDrag() { if (!drag.on) return; drag.on = false; track.classList.remove("is-dragging"); window.setTimeout(function () { drag.moved = false; }, 0); }
    window.addEventListener("pointerup", endDrag, { signal: signal });
    window.addEventListener("pointercancel", endDrag, { signal: signal });
    track.addEventListener("click", function (e) { if (!drag.moved) return; e.preventDefault(); e.stopPropagation(); }, true);
    links.forEach(function (link) {
      link.addEventListener("click", function (e) {
        var el = targetOf(link); e.preventDefault(); if (!el) return; activate(link, true); scrollToEl(el);
      });
    });
    sectionEl.addEventListener("transitionend", function (e) {
      if (e.propertyName !== "top" || sectionEl.style.top === "0px") return;
      sectionEl.style.zIndex = "";
    }, { signal: signal });
    window.addEventListener("scroll", spy, { passive: true, signal: signal });
    window.addEventListener("scrollend", function (e) { if (e.target === document || e.target === document.documentElement) release(); }, { signal: signal });
    window.addEventListener("resize", place, { signal: signal });
    if (typeof ResizeObserver === "function") {
      var ro = new ResizeObserver(place); ro.observe(sectionEl);
      signal.addEventListener("abort", function () { ro.disconnect(); });
    }
    var header = headerNode();
    if (header && typeof MutationObserver === "function") {
      var mo = new MutationObserver(pin);
      mo.observe(header, { attributes: true, attributeFilter: ["data-sticky-state", "data-animating"] });
      signal.addEventListener("abort", function () {
        mo.disconnect();
        var box = header.closest(".shopify-section");
        if (box) box.style.pointerEvents = "";
      });
    }
    layout(); spy();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { if (!signal.aborted) place(); });
  }
  window.saleNavBoot = boot;
  document.addEventListener("shopify:section:load", function (e) { boot(e.target); });
  document.addEventListener("shopify:section:unload", function (e) {
    var n = e.target && e.target.querySelector("[data-sale-nav]"); if (n && n.__saleNavAbort) n.__saleNavAbort.abort();
  });
  boot(document);
})();
